import { Pipe, PipeTransform } from '@angular/core';
import { SaIpsTransactionModal } from '../models/SaIpsTransaction.model';

@Pipe({
  name: 'saIpsTransactionFilter'
})
export class SaIpsTransactionFilterPipe implements PipeTransform {
  transform(LogData: any[], searchTermIpsTransaction: string): any[] {
    if (!LogData || !searchTermIpsTransaction) { return LogData; }

    LogData.forEach(element => {
      if(element.Date==null ){
        element.Date="";
      }
      if(element.Name==null ){
        element.Name="";
      }
      if(element.ProductName==null ){
        element.ProductName="";
      }
      if(element.isCompleted==null ){
        element.isCompleted="";
      }
     
    });
   

    return LogData.filter(ad =>
     
    
 
      ad.Date.toLowerCase().indexOf(searchTermIpsTransaction.toLowerCase().trim())!==-1
||
ad.Name.toLowerCase().indexOf(searchTermIpsTransaction.toLowerCase().trim())!==-1
||
ad.ProductName.toLowerCase().indexOf(searchTermIpsTransaction.toLowerCase().trim())!==-1
||
ad.isCompleted.toLowerCase().indexOf(searchTermIpsTransaction.toLowerCase().trim())!==-1

    );
  }

}
